import React from 'react';
import PropTypes from 'prop-types';
import { SOURCES } from './constants';
import { TextWrapper } from './styled';

/**
 * Source
 * @param type {number}
 * @returns {JSX.Element}
 */
const Source = ({ type = '-' }) => (
  <TextWrapper>{SOURCES[type] || '-'}</TextWrapper>
);

Source.propTypes = {
  type: PropTypes.string
};

export default Source;
